module.exports = __webpack_public_path__ + "static/media/BamaTheatre.81522ef0.jpg";